// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { forwardRef, LabelHTMLAttributes, Ref } from 'react';

import { BaseProps } from '../Base';
import { StyledSubLabel } from './Styled';

export interface SubLabelProps
  extends Omit<LabelHTMLAttributes<HTMLLabelElement>, 'css'>,
    BaseProps {}

export const SubLabel = forwardRef(
  (props: SubLabelProps, ref: Ref<HTMLLabelElement>) => {
    const { className, tag, ...rest } = props;

    return (
      <StyledSubLabel as={tag} className={className || ''} {...rest}>
        {props.children}
      </StyledSubLabel>
    );
  }
);
SubLabel.displayName = 'SubLabel';

export default SubLabel;
